import Image from "next/image"
import Link from "next/link"

import { SITE_BRAND } from "@/lib/site-nav"
import { cn } from "@/lib/utils"

export function SiteLogo({
  className,
  href = "/",
  tone = "light",
}: {
  className?: string
  href?: string
  /** light — тёмный текст на светлом фоне; dark — белый текст в футере */
  tone?: "light" | "dark"
}) {
  const markSrc =
    tone === "dark" ? "/favicon_64.png" : "/logo_main_white.png"

  return (
    <Link
      href={href}
      className={cn(
        "inline-flex items-center gap-1.5 whitespace-nowrap font-extrabold tracking-tight",
        tone === "dark" ? "text-white" : "text-foreground",
        className,
      )}
    >
      <Image
        src={markSrc}
        alt=""
        width={64}
        height={64}
        className="h-7 w-7 shrink-0 rounded-sm"
        priority
      />
      <span>
        {SITE_BRAND.name}
        <span className="text-primary">{SITE_BRAND.accent}</span>
      </span>
    </Link>
  )
}
